export enum PriceFactorType {
  UnionFactor = 1,
  ComplexityFactor = 2,
}
